<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <UserHeadTop />
            </a-layout-header>
            <a-layout-content class="order-mgmt-content-div">
                <div class="order-mgmt-card">
                    <div class="order-mgmt-title">
                        <span>订单管理</span>
                    </div>

                    <!-- 筛选栏 -->
                    <div class="filter-bar">
                        <a-select v-model:value="filterStatus" placeholder="订单状态" allowClear style="width: 140px"
                            @change="handleFilter">
                            <a-select-option :value="0">待支付</a-select-option>
                            <a-select-option :value="1">已完成</a-select-option>
                            <a-select-option :value="2">已取消</a-select-option>
                        </a-select>
                        <a-input v-model:value="filterOrderId" placeholder="搜索订单号" allowClear style="width: 220px"
                            @change="handleFilter" @pressEnter="handleFilter" />
                        <a-button type="primary" @click="handleFilter">查询</a-button>
                        <a-button @click="resetFilter">重置</a-button>
                    </div>

                    <a-table :data-source="orderList" :columns="columns" :loading="loading" row-key="order_id"
                        class="order-mgmt-table" size="middle" :pagination="false">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'orderInfo'">
                                <div class="order-info-cell">
                                    <div class="order-id-row">{{ record.order_id }}</div>
                                    <div class="goods-name-row">{{ record.goods_name }}</div>
                                    <div class="amount-row">￥{{ record.amount }}</div>
                                </div>
                            </template>
                            <template v-else-if="column.key === 'status'">
                                <a-tag :color="statusTagType(record.status)" size="small">
                                    {{ record.status_text || statusText(record.status) }}
                                </a-tag>
                            </template>
                            <template v-else-if="column.key === 'pay_mode'">
                                <a-tag size="small">
                                    {{ record.pay_mode === 'tenant' ? '自定义收款' : '系统收款' }}
                                </a-tag>
                            </template>
                            <template v-else-if="column.key === 'authInfo'">
                                <div class="auth-info-cell">
                                    <div class="auth-row">
                                        <span class="auth-label">邮箱</span>
                                        <span>{{ record.email || '-' }}</span>
                                    </div>
                                    <div class="auth-row">
                                        <span class="auth-label">授权</span>
                                        <span>{{ record.auth_value || '-' }}</span>
                                    </div>
                                    <div class="auth-row">
                                        <span class="auth-label">结果</span>
                                        <span>{{ record.auth_result || '-' }}</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="column.key === 'action'">
                                <a-button size="small" @click="openDetailDialog(record)">详情</a-button>
                                <a-button size="small" v-if="record.status === 0"
                                    @click="openEditDialog(record)">修改</a-button>
                                <a-button size="small" type="primary" ghost
                                    v-if="record.status === 0 && record.pay_mode === 'tenant'"
                                    @click="markPaid(record)">标记已付</a-button>
                            </template>
                        </template>
                    </a-table>

                    <div class="pagination">
                        <a-pagination v-model:current="currentPage" v-model:page-size="pageSize" :total="total"
                            show-size-changer :page-size-options="[10, 20, 50]"
                            :show-total="(t) => `共 ${t} 条`" @change="getOrderList" @showSizeChange="getOrderList" />
                    </div>
                </div>

                <!-- 订单详情弹窗 -->
                <a-modal v-model:open="detailDialogVisible" title="订单详情" width="600px" :footer="null">
                    <a-descriptions :column="1" bordered size="small">
                        <a-descriptions-item label="订单号">{{ currentOrder.order_id }}</a-descriptions-item>
                        <a-descriptions-item label="商品名称">{{ currentOrder.goods_name }}</a-descriptions-item>
                        <a-descriptions-item label="订单金额">￥{{ currentOrder.amount }}</a-descriptions-item>
                        <a-descriptions-item label="购买数量">{{ currentOrder.quantity }}</a-descriptions-item>
                        <a-descriptions-item label="订单状态">
                            <a-tag :color="statusTagType(currentOrder.status)" size="small">
                                {{ currentOrder.status_text || statusText(currentOrder.status) }}
                            </a-tag>
                        </a-descriptions-item>
                        <a-descriptions-item label="支付模式">
                            {{ currentOrder.pay_mode === 'tenant' ? '自定义收款' : '系统收款' }}
                        </a-descriptions-item>
                        <a-descriptions-item label="支付渠道">{{ currentOrder.pay_type }}</a-descriptions-item>
                        <a-descriptions-item label="下单邮箱">{{ currentOrder.email }}</a-descriptions-item>
                        <a-descriptions-item label="授权字段">{{ currentOrder.auth_value }}</a-descriptions-item>
                        <a-descriptions-item label="授权结果">{{ currentOrder.auth_result || '-' }}</a-descriptions-item>
                        <a-descriptions-item label="查询密码">{{ currentOrder.query_password }}</a-descriptions-item>
                        <a-descriptions-item label="下单时间">{{ currentOrder.created_at }}</a-descriptions-item>
                        <a-descriptions-item label="支付时间">{{ currentOrder.paid_at || '-' }}</a-descriptions-item>
                    </a-descriptions>
                    <template #footer>
                        <a-button @click="detailDialogVisible = false">关闭</a-button>
                    </template>
                </a-modal>

                <!-- 修改订单弹窗 -->
                <a-modal v-model:open="editDialogVisible" title="修改订单" width="500px" :mask-closable="false"
                    :footer="null">
                    <a-form :model="editForm" layout="vertical">
                        <a-form-item label="订单号">
                            <a-input :model-value="editForm.order_id" disabled />
                        </a-form-item>
                        <a-form-item label="授权字段">
                            <a-input v-model:value="editForm.auth_value" placeholder="请输入授权字段值" />
                        </a-form-item>
                        <a-form-item label="下单邮箱">
                            <a-input v-model:value="editForm.email" placeholder="请输入邮箱" />
                        </a-form-item>
                    </a-form>
                    <template #footer>
                        <a-button @click="editDialogVisible = false">取消</a-button>
                        <a-button type="primary" @click="submitEdit" :loading="submitting">确认修改</a-button>
                    </template>
                </a-modal>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { message, Modal } from 'ant-design-vue'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const orderList = ref<any[]>([])
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(20)
const total = ref(0)
const filterStatus = ref<number | undefined>(undefined)
const filterOrderId = ref('')

// 详情弹窗
const detailDialogVisible = ref(false)
const currentOrder = ref<any>({})

// 修改弹窗
const editDialogVisible = ref(false)
const editForm = ref({
    order_id: '',
    auth_value: '',
    email: '',
})
const submitting = ref(false)

const columns = [
    { title: '订单信息', key: 'orderInfo', minWidth: 260 },
    { title: '数量', dataIndex: 'quantity', key: 'quantity', width: 70 },
    { title: '状态', key: 'status', width: 90 },
    { title: '支付模式', key: 'pay_mode', width: 100 },
    { title: '授权信息', key: 'authInfo', minWidth: 220 },
    { title: '下单时间', dataIndex: 'created_at', key: 'created_at', width: 170 },
    { title: '操作', key: 'action', width: 230, fixed: 'right' },
]

const statusText = (status: number) => {
    const map: Record<number, string> = { 0: '待支付', 1: '已完成', 2: '已取消' }
    return map[status] || '未知'
}

const statusTagType = (status: number) => {
    const map: Record<number, string> = { 0: 'gold', 1: 'green', 2: 'default' }
    return map[status] || 'default'
}

const getOrderList = async () => {
    loading.value = true
    try {
        const params: any = {
            page: currentPage.value,
            pageSize: pageSize.value,
        }
        if (filterStatus.value !== undefined && filterStatus.value !== '') {
            params.status = filterStatus.value
        }
        if (filterOrderId.value) {
            params.order_id = filterOrderId.value
        }
        const res = await axios.post(baseURL + '/api/shop/tenant/order/list', params, { headers })
        if (res.data.code === 0) {
            const data = res.data.data
            orderList.value = data.list || []
            total.value = data.total || 0
        } else {
            message.error(res.data.msg || '获取订单列表失败')
        }
    } catch (e: any) {
        message.error('获取订单列表失败：' + e.message)
    } finally {
        loading.value = false
    }
}

const handleFilter = () => {
    currentPage.value = 1
    getOrderList()
}

const resetFilter = () => {
    filterStatus.value = undefined
    filterOrderId.value = ''
    currentPage.value = 1
    getOrderList()
}

const openDetailDialog = (row: any) => {
    currentOrder.value = { ...row }
    detailDialogVisible.value = true
}

const openEditDialog = (row: any) => {
    editForm.value = {
        order_id: row.order_id,
        auth_value: row.auth_value || '',
        email: row.email || '',
    }
    editDialogVisible.value = true
}

const submitEdit = async () => {
    submitting.value = true
    try {
        const payload: any = { order_id: editForm.value.order_id }
        if (editForm.value.auth_value) payload.auth_value = editForm.value.auth_value
        if (editForm.value.email) payload.email = editForm.value.email
        const res = await axios.post(baseURL + '/api/shop/tenant/order/update', payload, { headers })
        if (res.data.code === 0) {
            message.success('修改成功')
            editDialogVisible.value = false
            getOrderList()
        } else {
            message.error(res.data.msg || '修改失败')
        }
    } catch (e: any) {
        message.error('修改失败：' + e.message)
    } finally {
        submitting.value = false
    }
}

const markPaid = (row: any) => {
    Modal.confirm({
        title: '确认标记已支付',
        content: `确认将订单「${row.order_id}」标记为已支付吗？\n标记后系统将执行扣款、授权、反利等逻辑，此操作不可撤销。`,
        okText: '确认标记',
        cancelText: '取消',
        onOk: async () => {
            try {
                const res = await axios.post(baseURL + '/api/shop/tenant/order/markPaid', { order_id: row.order_id }, { headers })
                if (res.data.code === 0) {
                    message.success('订单已标记为已支付')
                    getOrderList()
                } else {
                    message.error(res.data.msg || '操作失败')
                }
            } catch (e: any) {
                message.error('操作失败：' + e.message)
            }
        },
    })
}

onMounted(() => {
    getOrderList()
})
</script>

<style scoped lang="scss">
.order-mgmt-content-div {
    height: 100vh;
    background-color: #f2f3f5 !important;
    overflow-y: auto;
}

.order-mgmt-card {
    background-color: white;
    padding: 2rem;
    margin: 1.5rem;
    border-radius: 0.75rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.order-mgmt-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #2563eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.filter-bar {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
}

.order-mgmt-table {
    width: 100%;
}

.order-info-cell {
    .order-id-row {
        font-size: 0.8rem;
        color: #94a3b8;
        margin-bottom: 0.2rem;
    }

    .goods-name-row {
        font-size: 0.9rem;
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .amount-row {
        font-size: 0.95rem;
        font-weight: 700;
        color: #d97706;
    }
}

.auth-info-cell {
    .auth-row {
        font-size: 0.82rem;
        line-height: 1.7;
        color: #475569;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .auth-label {
        color: #94a3b8;
        margin-right: 0.4rem;
        flex-shrink: 0;
    }
}

.pagination {
    margin: 1.5rem auto 0;
    width: fit-content;
}

@media screen and (max-width: 768px) {
    .order-mgmt-card {
        margin: 1rem;
        padding: 1.2rem;
    }
}
</style>
